import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { profileData } from "../data/profileData";

const About = () => {
	const { ref, inView } = useScrollAnimation();

	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: { staggerChildren: 0.15 },
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.6 },
		},
	};

	return (
		<section id="about" className="section-card" ref={ref}>
			<motion.div
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={containerVariants}
			>
				<motion.div className="section-header" variants={itemVariants}>
					<span>About</span>
					<h2>Career profile</h2>
				</motion.div>
				<div className="about-bento-layout">
					<motion.div className="about-bio-container" variants={itemVariants}>
						<p className="about-intro">
							{profileData.aboutSummary}
						</p>
						<p className="about-extended-bio">
							I solve complex engineering challenges with reusable component systems, clean state management, and robust API contracts. Focused on bridging the gap between product requirements and high-performance, maintainable delivery.
						</p>
					</motion.div>
					
					<motion.div className="about-cards-container" variants={containerVariants}>
						<motion.div className="about-bento-card" variants={itemVariants}>
							<h3>What I build</h3>
							<ul>
								{profileData.aboutPoints.map((point) => (
									<li key={point}>{point}</li>
								))}
							</ul>
						</motion.div>
						
						<motion.div className="about-bento-card" variants={itemVariants}>
							<h3>Professional value</h3>
							<p>
								I focus on delivering clean UX, reliable backend systems, and
								clearly structured code that supports long-term product growth.
							</p>
						</motion.div>
					</motion.div>
				</div>
			</motion.div>
		</section>
	);
};

export default About;
